// [TEL-2256] O texto de IA da chamada (resumo gerencial e análise qualitativa) chega do
// connectors-service com marcação Markdown. A tela imprimia esse texto cru dentro de um <p> com
// `white-space: pre-line`, então o usuário lia "## Resumo Gerencial" e "**Preço**" literalmente.
//
// Espelha o `lib/helpers/markdown.js` do pbxapi, que já usa markdown-it para o mesmo texto ao
// enviá-lo para os CRMs — mesma lib, mesma versão, para que os dois lados interpretem a saída da
// IA igual.
import markdownit from 'markdown-it'

// Única divergência proposital em relação ao helper do pbxapi: `html: false`.
// Lá o destino é o campo de texto de um CRM; aqui a saída vai para `v-html` no navegador do
// cliente, e o texto é gerado por um LLM a partir da transcrição — ou seja, conteúdo não confiável.
// Com `html: true`, um `<img src=x onerror=...>` que aparecesse na transcrição seria injetado no
// DOM como HTML de verdade. Com `false`, markdown-it escapa a marcação e ela vira texto visível.
// O `validateLink` padrão do markdown-it complementa isso barrando href `javascript:`/`data:`.
const MD = markdownit({
  html: false,
  linkify: true,
  typographer: true
})

// linkify gera <a> sem target; abrir link de terceiro na mesma aba tiraria o usuário do relatório,
// e sem `rel` a página de destino ganharia acesso a `window.opener`.
const defaultLinkOpen =
  MD.renderer.rules.link_open ||
  function (tokens, idx, options, env, self) {
    return self.renderToken(tokens, idx, options)
  }

MD.renderer.rules.link_open = function (tokens, idx, options, env, self) {
  tokens[idx].attrSet('target', '_blank')
  tokens[idx].attrSet('rel', 'noopener noreferrer')
  return defaultLinkOpen(tokens, idx, options, env, self)
}

export function convertMarkdownToHTML (content) {
  if (!content) return ''
  return MD.render(content)
}

export default convertMarkdownToHTML



// WEBPACK FOOTER //
// ./src/utils/markdown.js